import { CommonModule } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { ApiRequestService } from '@prekog/common-ui';
import { SpecialityType } from '../../specialities/addspeciality/specialitytype';
import { AddSpecialityTypeRequest } from './addspecialitytyperequest';

@Component({
    selector: 'app-addspecialitytype',
    templateUrl: './addspecialitytype.component.html',
    styleUrls: ['./addspecialitytype.component.scss'],
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, RouterModule]
})
export class AddspecialitytypeComponent {
    addSpecialityTypeUrl = '/admin/add-specialitytype';

    regeneroBaseUrl = '';

    specialityType: SpecialityType = {};

    specialityTypeForm?: FormGroup;

    constructor(
        public _router: Router,
        private _apiRequestService: ApiRequestService,
        @Inject('REGENERO_BASE_URL') private _regeneroBaseUrl: string,
        private _fb: FormBuilder
    ) {
        this.regeneroBaseUrl = _regeneroBaseUrl;

        this.createSpecialityTypeForm();
    }

    createSpecialityTypeForm() {
        this.specialityTypeForm = this._fb.group({
            name: ['', [Validators.required]],
            jobTitle: ['', [Validators.required]]
        });
    }

    collectSpecialityTypeData() {
        this.specialityType = {
            name: this.specialityTypeForm?.controls['name'].value as string | undefined,
            jobTitle: this.specialityTypeForm?.controls['jobTitle'].value as string | undefined
        };
    }

    addSpecialityType() {
        this.collectSpecialityTypeData();

        const addSpecialityTypeRequest: AddSpecialityTypeRequest = {
            specialityType: this.specialityType
        };

        this._apiRequestService
            .sendRequest<
                AddSpecialityTypeRequest,
                HttpResponse<any>
            >(this.regeneroBaseUrl, addSpecialityTypeRequest, true, this.addSpecialityTypeUrl, true)
            .subscribe();
    }
}
